<div class = "row my-row pt-5 pb-5">

    <div class="col-xl-12 my-col">
        <h1>{{ "SUPER-ADMIN.SIDE-MENU.CLIENT-ADMIN" | translate }}</h1>
    </div>

    <div class='container-fluid my-container'>
        <div class='row my-row'>
            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SUPER-ADMIN.CLIENT.CARD-LIST-TITLE" | translate }}
                    </div>
                    <div class='card-body'>
                        <div class='container-fluid my-container'>
                            <app-error [error_message]="errorMessageListClient" [error_type]="errorTypeListClient"></app-error>

                            <div class="row my-row" *ngIf="tabClients">
                                <div class="col-lg-12 my-col order-sm-last">
                                    <mat-form-field class="w-50">
                                        <input matInput #search (keyup)="applyFilter(search.value)" placeholder="{{ 'SUPER-ADMIN.CLIENT.LIST.SEARCH' | translate }}">
                                    </mat-form-field>
                                    <button type="button" class="btn btn-primary mx-2" id="refreshTable" name="refreshTable"
                                            data-toggle="tootip" data-placement="top"
                                            title="{{ 'SUPER-ADMIN.CLIENT.LIST.BUTTONS.REFRESH' | translate }}"
                                            (click)="loadTabClient()">
                                        <em class="bi bi-arrow-clockwise"></em>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="tabClients" class="table-container mat-elevation-z8">
                                <div class="example-table-container">
                                    <table mat-table id="clients" class="exemple-table w-100" [dataSource]="tabClients">
                                        
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef class="pl-4 text-primary">
                                                <h6>{{ "SUPER-ADMIN.CLIENT.LIST.NAME" | translate }}</h6>
                                            </th>
                                            <td mat-cell *matCellDef="let client" class="truncate-cell pl-4"
                                            data-toggle="tootip" data-placement="top" title="{{client.name}}">
                                                <p>{{ client.name }}</p>
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="actions">
                                            <th mat-header-cell *matHeaderCellDef class="text-center text-primary">
                                                <h6>{{ "SUPER-ADMIN.CLIENT.LIST.ACTIONS" | translate }}</h6>
                                            </th>
                                            <td mat-cell *matCellDef="let client" style="text-align: center">  
                                                <button type="button" class="btn-warning btn ml-2"
                                                        data-toggle="tootip" data-placement="top"
                                                        title="{{ 'SUPER-ADMIN.CLIENT.LIST.BUTTONS.EDIT-CLIENT' | translate }}" 
                                                        (click)="$event.stopPropagation();infoClient(client)">
                                                        <em class="bi bi-pencil"></em>
                                                </button>
                                            </td>
                                        </ng-container>
                    
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    
                                    </table>
                                </div>
                                <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SUPER-ADMIN.CLIENT.CARD-ADD-ONE-CLIENT" | translate }}
                    </div>
                    <div class='card-body'>
                        <app-client-form></app-client-form>
                    </div>
                </div>
            </div>

            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SUPER-ADMIN.CLIENT.CARD-LOADCLIENT" | translate }}
                    </div>
                    <div class='card-body'>
                        <app-error [error_message]="errorMessageLoadClient" [error_type]="errorTypeLoadClient"></app-error>
                        <div class="row">
                            <div class="col-sm">
                                <div class="alert alert-success" role="alert">
                                    {{ "SUPER-ADMIN.CLIENT.LOADCLIENT.TEXT-INFO" | translate }} 
                                    <a class="link-info font-weight-bold" (click)="downloadLoadClient()">
                                        {{ "SUPER-ADMIN.CLIENT.LOADCLIENT.TEXT-INFO-LINK-LOADCLIENT" | translate }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm">
                                <input type="file" #uploadFileInput id="fileUpload" name="fileUpload" accept=".xlsx" (change)="fileUpdate()"/>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm">
                                <button [disabled]="!fileUpload" type="button" class="btn btn-primary" (click)="loadClient(uploadFileInput)">
                                    {{ "BUTTONS.LOADCLIENT" | translate }}
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2" *ngIf="this.resSuccess.length > 0 || this.resError.length > 0">
                            <div class="col-sm" *ngIf="this.resSuccess.length > 0">
                                <h3>{{ "SUPER-ADMIN.CLIENT.LOADCLIENT.LIST-SUCCESS" | translate }}</h3>
                                <ul>
                                    <li *ngFor="let success of this.resSuccess">
                                        <p class="text-success">{{success}}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm" *ngIf="this.resError.length > 0">
                                <h3>{{ "SUPER-ADMIN.CLIENT.LOADCLIENT.LIST-ERRORS" | translate }}</h3>
                                <ul>
                                    <li *ngFor="let error of this.resError">
                                        <p class="text-danger">{{error}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
